import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ChildPriceDropdown,
  MasterPriceListDropdown,
  PropertyResourceDropdown,
} from "../../../../redux/Thunk/ClientModule/ClientThunk";
import { Box, Chip, FormControl, FormLabel, Grid, MenuItem, Paper, Select, Typography } from "@mui/material";
import DropdownComponent from "../../../../Components/DropdownComponent";
import { validateFields } from "../../../../Helper/ValidateFields";
import {
  deleteProperties,
  getPropertyExternalResource,
  getSearchedCriteria,
  SaveUserProperty,
} from "../../../../redux/Thunk/externalResourceThunk";
import { useLocation, useParams } from "react-router-dom";
import Btn from "../../../../Components/Ui_elements/Btn";
import GenericTable from "../../../../Components/Ui_elements/GenericTable";
import PopupModal from "../../../../Components/Ui_elements/PopupModal";

const Step2 = ({ registerSubmit }) => {
  const dispatch = useDispatch();
  const { property_resource_drpdown } = useSelector(state => state.root.ClientModule);
  const { new_external_created, searched_criteria_dropdown, propertyExternalResource } =
    useSelector(state => state.root.ExternalResource);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cId = searchParams.get("c_id");
  const { id } = useParams();

  let searchedCriteria = Array.isArray(searched_criteria_dropdown?.data)
    ? searched_criteria_dropdown?.data
    : [];
  const newId = cId ? cId : id;
  const paydata = { user_id: newId };

  const [errors, setErrors] = useState({});
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [formData, setFormData] = useState({ property: "", criteria: [] });

  const formFields = [{ name: "property", label: "Property" }];

  useEffect(() => {
    dispatch(PropertyResourceDropdown());
    dispatch(getPropertyExternalResource(paydata));
    dispatch(MasterPriceListDropdown());
    dispatch(ChildPriceDropdown());
  }, [dispatch]);

  useEffect(() => {
    if (formData.property) {
      dispatch(getSearchedCriteria({ id: newId, propertyId: formData.property }));
    }
  }, [formData.property, newId]);

  const handleSubmit = e => {
    if (e && e.preventDefault) e.preventDefault();

    const newErrors = validateFields(formData, formFields);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const payload = {
      property_id: formData.property,
      value_id: formData.criteria.join(","),
      user_id: String(newId),
      type: "1",
    };
    dispatch(SaveUserProperty(payload)).then(() => {
      dispatch(getPropertyExternalResource(paydata));
    });
    setFormData({ property: "", criteria: [] });
    return true;
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    // setFormData((prev) => ({ ...prev, [name]: value }));
    // setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData({
      ...formData, // still spreading manually, not using prev
      [name]: value,
      ...(name === "property" ? { criteria: [] } : {}),
    });

    setErrors({
      ...errors,
      [name]: "",
      ...(name === "property" ? { criteria: "" } : {}),
    });
  };

  const handleMultiSelectChange = e => {
    setFormData(prevState => ({ ...prevState, criteria: e.target.value }));
    setErrors(prevErrors => ({ ...prevErrors, criteria: "" }));
  };

  const handleChipDelete = value => {
    setFormData(prevState => ({
      ...prevState,
      criteria: prevState.criteria.filter(item => item !== value),
    }));
  };

  const propertyOptions =
    property_resource_drpdown?.data?.map(item => ({
      label: item.property_name,
      value: item.property_id,
    })) || [];

  const columns = [
    {
      name: "rowNumber",
      label: "No.",
      options: {
        display: true,
        setCellProps: () => ({ style: { width: '60px' } }),
        setHeaderProps: () => ({ style: { width: '60px' } })
      }
    },
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
        setCellProps: () => ({ style: { width: '80px' } }),
        setHeaderProps: () => ({ style: { width: '80px' } })
      }
    },
    {
      name: "property_name",
      label: "Property Name",
      options: {
        setCellProps: () => ({ style: { width: '100px' } }),
        setHeaderProps: () => ({ style: { width: '100px' } })
      }
    },
    {
      name: "values_names",
      label: "Values",
      options: {
        setCellProps: () => ({ style: { width: '250px' } }),
        setHeaderProps: () => ({ style: { width: '250px' } })
      }
    },
  ];


  const data = propertyExternalResource?.data?.map((item, index) => ({
    rowNumber: index + 1,
    id: item.id,
    values_names: item.values_names,
    property_name: item.property_name,
  }));

  const handleEdit = rowData => {
    const selectedData = propertyExternalResource?.data?.find(
      item => item.id == rowData[1]
    );

    if (!selectedData) return;

    setFormData({
      property: selectedData.property_id,
      criteria: [],
    });

    setTimeout(() => {
      setFormData(prev => ({
        ...prev,
        criteria: selectedData.value_id
          ? String(selectedData.value_id).split(",")
          : [],
      }));
    }, 0);
  };



  const handleDelete = id => {
    setOpenForDelete(true);
    setDeleteId(id[1]);
  };

  useEffect(() => {
    registerSubmit(handleSubmit);
  }, [formData]);

  const StyledPropertyTable = ({ columns, data, onEdit, onDelete }) => {
    const tableOptions = {
      selectableRows: 'none',
      responsive: 'standard',
      download: false,
      print: false,
      filter: false,
      viewColumns: false,
      pagination: false,
      search: false,
      sort: false,
      setRowProps: (row, dataIndex, rowIndex) => ({
        style: {
          backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#f8f9fa'
        }
      }),
      setTableProps: () => ({
        style: {
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          overflow: 'hidden'
        }
      })
    };

    return (
      <Box sx={{
        '& .MuiTableRow-head': {
          backgroundColor: '#f5f5f5',
        },
        '& .MuiTableCell-head': {
          fontWeight: 'bold',
          borderBottom: '2px solid #e0e0e0'
        },
        '& .MuiTableBody-root .MuiTableRow-root:hover': {
          backgroundColor: '#f0f0f0'
        }
      }}>
        <GenericTable
          columns={columns}
          data={data}
          onEdit={onEdit}
          onDelete={onDelete}
          showPagination={false}
          showClientSideSearch={false}
          options={tableOptions}
        />
      </Box>
    );
  };

  return (
    <Box sx={{ p: 1, minHeight: "100vh" }}>
      <Box sx={{ p: 2, mb: 4, borderRadius: 2 }} className="whiteBackground">
        <Typography variant="h6" gutterBottom>
          Add / Update Property
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} mb={2}>
            <Grid item xs={6} sm={3}>
              <DropdownComponent
                label="Property"
                name="property"
                value={formData.property}
                onChange={handleInputChange}
                options={propertyOptions}
                isNotMandatory={true}
                error={errors.property || ""}
              />
            </Grid>
            <Grid item xs={3}>
              {formData.property && (
                <FormControl fullWidth>
                  <FormLabel error={!!errors.criteria}>{errors.criteria || "Criteria"}</FormLabel>
                  <Select
                    multiple
                    name="criteria"
                    value={formData.criteria || []}
                    onChange={handleMultiSelectChange}
                    renderValue={selected => (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                        {selected.map(valueId => (
                          <Chip
                            key={valueId}
                            label={
                              searchedCriteria.find(
                                opt => String(opt.value_id) === String(valueId)
                              )?.value_name || valueId
                            }
                            onMouseDown={e => e.stopPropagation()}
                            onDelete={() => handleChipDelete(valueId)}
                          />
                        ))}
                      </div>
                    )}
                  >
                    {searchedCriteria.length > 0 ? (
                      searchedCriteria.map(opt => (
                        <MenuItem key={opt.value_id} value={String(opt.value_id)}>
                          {opt.value_name}
                        </MenuItem>
                        // <MenuItem key={opt.value_id} value={opt.value_id}>
                        //   {opt.value_name}
                        // </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No criteria available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid item xs={4} mt={3}>
              <Btn type="submit" variant="contained">
                Save Property
              </Btn>
            </Grid>
          </Grid>
        </form>
      </Box>
      <Box sx={{ p: 2, borderRadius: 2 }} className="whiteBackground">
        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
          Property List
        </Typography>
        <StyledPropertyTable
          columns={columns}
          data={data}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </Box>
      {openForDelete && (
        <PopupModal
          maxWidth={"sm"}
          fullWidth={true}
          open={openForDelete}
          handleClose={() => setOpenForDelete(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn
                onClick={() =>
                  dispatch(deleteProperties(deleteId)).then(() => {
                    setFormData({ property: "", criteria: [] });
                    dispatch(getPropertyExternalResource(paydata));
                    setOpenForDelete(false);
                  })
                }
              >
                Yes
              </Btn>
              <Btn onClick={() => setOpenForDelete(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Delete Properties</Typography>}
        >
          <Typography>Are you sure you want to delete the properties?</Typography>
        </PopupModal>
      )}
    </Box>
  );
};

export default Step2;
